const PARSE_ERROR_FALLBACK_PATH = '/could-not-parse/';
export const PARSE_ERROR_FALLBACK_URL = `https://unknown.example.com${PARSE_ERROR_FALLBACK_PATH}`;

const defaultMappings = [
	{
		matcher: /^\/browse\/.*/i,
		transformer: '/browse/:issueKey',
	},
	{
		matcher: /^\/project\/[A-Z][A-Z0-9]+\/issues/i,
		transformer: '/project/:projectKey/issues',
	},
	{
		matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/issues/i,
		transformer: '/jira/software/projects/:projectKey/issues',
	},
	{
		matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/issues/i,
		transformer: '/jira/software/c/projects/:projectKey/issues',
	},
	{
		matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/issues/i,
		transformer: '/jira/servicedesk/projects/:projectKey/issues',
	},
	{
		matcher: /^\/jira\/core\/projects\/[A-Z][A-Z0-9]+\/issues/i,
		transformer: '/jira/core/projects/:projectKey/issues',
	},
	{
		matcher: /^\/issues/i,
		transformer: '/issues',
	},
	{
		matcher: /^\/jira\/issues/i,
		transformer: '/jira/issues',
	},
	{
		matcher:
			/^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/backlog|\/roadmap|\/timeline)?/i,
		transformer: (match: RegExpMatchArray) =>
			`/jira/software/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`,
	},
	{
		matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/roadmap|\/timeline)?/i,
		transformer: (match: RegExpMatchArray) =>
			`/jira/software/c/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`,
	},
	{
		matcher: /^\/rest\/agile\/(.*?)\/board\/\d+\/configuration/i,
		transformer: (match: RegExpMatchArray) =>
			`/rest/agile/${match[1]}/board/:boardId/configuration`,
	},
	{
		matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/backlog\/sprint-commitment/i,
		transformer: '/gateway/api/insights/agile/board/:boardId/backlog/sprint-commitment',
	},
	{
		matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/workload/i,
		transformer: '/rest/internal/board/:boardId/sprint/:sprintId/workload',
	},
	{
		matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/sprint-progress/i,
		transformer: '/rest/internal/board/:boardId/sprint/:sprintId/sprint-progress',
	},
	{
		matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/blocked-issues/i,
		transformer: '/rest/internal/board/:boardId/sprint/:sprintId/blocked-issues',
	},
	{
		matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/epic-progress/i,
		transformer: '/rest/internal/board/:boardId/sprint/:sprintId/epic-progress',
	},
	{
		matcher: /^\/gateway\/api\/aris\/jira\/[a-f0-9-]+\/board\/\d+\/config/i,
		transformer: '/gateway/api/aris/jira/:cloudId/board/:boardId/config',
	},
	{
		matcher: /^\/gateway\/api\/jira-insights\/settings\/board\/\d+\/permissions\/board-admin/i,
		transformer: '/gateway/api/jira-insights/settings/board/:boardId/permissions/board-admin',
	},
	{
		matcher: /\/gateway\/api\/jira-insights\/settings\/board\/\d+/i,
		transformer: '/gateway/api/jira-insights/settings/board/:boardId',
	},
	{
		matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/sprint\/\d+\/burndown/i,
		transformer: '/gateway/api/insights/agile/board/:boardId/sprint/:sprintId/burndown',
	},
	{
		matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/queues\/custom\/\d+/i,
		transformer: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey',
	},
	{
		matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/section\/[A-Z]+\/custom\/\d+/i,
		transformer:
			'/jira/servicedesk/projects/:projectKey/section/:category/custom/:queueId/:issueKey',
	},
	{
		matcher: /^\/projects\/[A-Z][A-Z0-9]+\/settings(\/[a-z]+)?/i,
		transformer: (match: RegExpMatchArray) => `/projects/settings${match[1] ? match[1] : ''}`,
	},
	{
		matcher:
			/^\/projects\/[A-Z][A-Z0-9]+.*?selectedItem=com\.atlassian\.jira\.jira-projects-plugin:(\w+)/i,
		transformer: (match: RegExpMatchArray) =>
			`/projects/:projectKey?selectedItem=com.atlassian.jira.jira-projects-plugin:${match[1]}`,
	},
	{
		matcher:
			/^\/secure\/ConfigureReport!default.jspa.*?reportKey=com.atlassian.jira.plugin.system.reports:(\w+)/i,
		transformer: (match: RegExpMatchArray) =>
			`/secure/ConfigureReport!default.jspa?reportKey=com.atlassian.jira.plugin.system.reports:${match[1]}`,
	},
	{
		matcher: /^\/secure\/((.*?\/)?\w+.jspa)/i,
		transformer: (match: RegExpMatchArray) => `/secure/${match[1]}`,
	},
	{
		matcher: /^\/plugins\/servlet\/(\w+)/i,
		transformer: (match: RegExpMatchArray) => `/plugins/servlet/${match[1]}`,
	},
	{
		matcher: /^\/jira\/your-work/i,
		transformer: '/jira/your-work',
	},
	// Part of the hack around detecting invalid URLs, if we've parsed to the fallback URL, then
	// we return the fallback path instead of the generic "unknown" path
	{
		matcher: new RegExp(PARSE_ERROR_FALLBACK_PATH),
		transformer: '/could-not-parse/',
	},
	{
		matcher: null,
		transformer: '/unknown',
	},
];

export default defaultMappings;
